import { Tip, TipType } from "../../../Tip/Tip"

export const TipSamson = () => {
  return (
    <Tip
      type={TipType.WARNING}
      content={
        <span>
          <b>Внимание! </b>
          <p>
            Файл перекодировки должен быть формата <b> XLSX </b> и содержать
            следующие <b> обязательные </b> колонки:
          </p>
          <ol style={{ textAlign: "left" }}>
            <li>
              <b>article </b> - артикул товара с Самсон ОПТ
            </li>
            <li>
              <b>GoodCode </b> - артикул продавца с WB
            </li>
            <li>
              <b>nmId </b> - артикул ВБ
            </li>
            <li>
              <b>sku </b> - баркод с WB
            </li>
            <li>
              <b>sizes </b> - размеры упаковки, в см. В формате: "10;10;10";
            </li>
            <li>
              <b>count </b> - количество товаров продаваемых в карточке
              (кратность)
            </li>
            <li>
              <b>commission </b> - комиссия. Если не заполнено, то будет
              использовано значение из параметра цен
            </li>
          </ol>
        </span>
      }
    />
  )
}
